// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"textformat-color"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 17L11.5 3H12.5L18.5 17M8.08 12.1387L15.92 12.1394","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 21H5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextformatColorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textformat-color',
    ref,
    icon: element,
  },
));

TextformatColorIcon.displayName = 'TextformatColorIcon';

export default TextformatColorIcon;
